import "./BottomBar.css";

/** Purely decorative HUD hint bar, echoing the game's button prompts. */
export default function BottomBar() {
  return (
    <div className="bottombar" aria-hidden="true">
      <div className="bottombar__badge">
        <span className="bottombar__level">EST · OTTAWA</span>
        <span className="bottombar__sep" />
        <span className="bottombar__pts">CS · AI/ML</span>
      </div>
    </div>
  );
}
